import type { RatingDistributionDto } from '@up2stay/up2promo-api-client';
import { Card, cn } from '@up2stay/up2promo-ui';

import { ratingBarFill } from '@/core/components/reputation/reputation-chart-config';
import { REPUTATION_SECTION_TITLE_CLASS } from '@/core/components/reputation/reputation-surface';

const STARS = [5, 4, 3, 2, 1] as const;

export function AnalyticsRatingCard({
  distribution,
  total,
  title,
  subtitle,
  className,
}: {
  distribution: RatingDistributionDto;
  total: number;
  title: string;
  /** `{count}` is replaced with the review total. */
  subtitle: string;
  className?: string;
}) {
  const max = Math.max(...STARS.map((star) => distribution[star]), 1);
  return (
    <Card className={cn('flex min-w-0 flex-col p-5 sm:p-6', className)}>
      <h2 className={REPUTATION_SECTION_TITLE_CLASS}>{title}</h2>
      <p className="text-muted-foreground mb-4 mt-0.5 text-[12.5px]">
        {subtitle.replace('{count}', String(total))}
      </p>
      <div className="grid flex-1 grid-cols-5 items-end gap-3">
        {STARS.map((star) => {
          const count = distribution[star];
          return (
            <div
              key={star}
              className="flex h-full min-h-[170px] flex-col items-center justify-end gap-2"
            >
              <span
                className={cn(
                  'font-mono text-xs',
                  count > 0 ? 'font-semibold' : 'text-muted-foreground',
                )}
              >
                {count}
              </span>
              <div
                className="w-full rounded-t-lg rounded-b-[3px]"
                style={{
                  height:
                    count > 0 ? `${Math.max(8, (count / max) * 130)}px` : 4,
                  background: count > 0 ? ratingBarFill(star) : 'var(--muted)',
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="text-muted-foreground mt-2 grid grid-cols-5 gap-3 text-center text-xs">
        {STARS.map((star) => (
          <span key={star}>{star}★</span>
        ))}
      </div>
    </Card>
  );
}
